export default {
	leaderBoard: {
		show: 'recent',
		campers: [],
		loading: false,
		message: '',
	}
};


/** WEBPACK FOOTER **
 ** ./src/reducers/initialState.js
 **/